import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetDataIdBlog, RejectComment } from "../Components/Services";
import Loading from "../../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import { ToTimeJalali } from "../../../../Common/Function";
import RateRender from "../../../../Common/Components/RateRender";

function Blogs() {
  const { id } = useParams();
  const initialState = {
    loading: true,
    data: {
      data: null,
      current_page: null,
      id: null,
    },
  };
  const Handler = () => {
    setState({ ...state, loading: true });
    GetDataIdBlog(id).then(result => {
      setState({
        loading: false,
        data: result,
      });
    });
  };

  const ConfirmHandler = data => {
    setState({ ...state, loading: true });
    // ConfirmComment(data).then(() => {
    // Handler();
    // });
  };
  const RejectHandler = data => {
    setState({ ...state, loading: true });
    RejectComment(data).then(() => {
      Handler();
    });
  };
  const [state, setState] = useState(initialState);

  function Comments({ data }) {
    return (
      <div>
        <div className="item rounded-3 bg-light p-3 mb-2 shadow-sm">
          <div className="first mb-2 d-flex flex-wrap justify-content-between text-center text-sm-start">
            <div className="user col-sm-auto col-12 d-flex flex-wrap align-items-center">
              <div className="details col-sm-auto col-12">
                <p className="font-sm">
                  <span className="ms-2">{ToTimeJalali(data.created_at)}</span>
                </p>
              </div>
            </div>
            {data.status === "off" ? (
              <div>
                <div
                  type="button"
                  onClick={() => ConfirmHandler(data.id)}
                  className="d-inline-block btn btn-success rounded-2 m-1 s-button px-3"
                >
                  تایید
                </div>
                <div
                  onClick={() => RejectHandler(data.id)}
                  type="button"
                  className="d-inline-block btn btn-danger m-1 rounded-2 s-button px-3"
                >
                  رد کردن
                </div>
              </div>
            ) : (
              <div
                type="button"
                onClick={() => RejectHandler(data.id)}
                className="d-inline-block btn btn-danger rounded-2 s-button px-3"
              >
                حذف
              </div>
            )}
          </div>
          <div className="second ps-md-5 bg-light-warning text-dark p-2 rounded">
            <p className="h5">{data.text}</p>
            <RateRender data={data.score} />
          </div>
        </div>
      </div>
    );
  }

  useEffect(() => {
    Handler();
  }, [id]);
  const Empty = () => {
    return <h5 className="text-center">کامنتی ثبت نشده است</h5>;
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست کامنت ها</title>
      </Helmet>

      {state.loading ? (
        <Loading count={1} col={12} height={180} />
      ) : (
        <Fragment>
          {state &&
          state.data &&
          state.data &&
          state.data.comments.data.length === 0
            ? Empty()
            : state.data.comments.data.map((item, i) => {
                return <Comments data={item} key={i} />;
              })}
        </Fragment>
      )}
    </Fragment>
  );
}

export default Blogs;
